import React, { Component } from 'react';
import { noop } from 'lodash';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import looppa from 'looppa';
import uid from 'util/misc/uid';

export default class FormField extends Component {
    static defaultProps = {
        facet: '',
        hasFloatingLabel: false,
        type: '',
        id: '',
        value: '',
        label: '',
        placeholder: '',
        onFocus: noop,
        onBlur: noop,
        state: {
            error: false,
            required: false,
            disabled: false,
            focus: false,
        },
        messages: {
            error: [],
        },
    };

    static propTypes = {
        facet: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
        variant: PropTypes.string,
        type: PropTypes.string.isRequired,
        component: PropTypes.func.isRequired,
        hasFloatingLabel: PropTypes.bool,
        id: PropTypes.string,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool, PropTypes.array]).isRequired,
        state: PropTypes.object,
        label: PropTypes.string,
        placeholder: PropTypes.string,
        messages: PropTypes.object,
        onInput: PropTypes.func,
        onFocus: PropTypes.func.isRequired,
        onBlur: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);

        this._id = props.id || `v-uid-${ uid() }`;
        this.state = {
            stateClasses: {},
            value: props.value,
            hasFocus: props.state.focus,
        };
    }

    onBlur() {
        this.props.onBlur();
        this.setState({ hasFocus: false });
    }

    onFocus() {
        this.props.onFocus();
        this.setState({ hasFocus: true });
    }

    setStateClasses(stateClasses) {
        this.setState({ stateClasses });
    }

    get actionCount() {
        let count = 0;
        count += (this.props.type === 'date' ? 1 : 0);

        return count;
    }

    get formClasses() {
        const { state, hasFloatingLabel, placeholder } = this.props;
        const { hasFocus } = this.state;
        const classes = {
            'form-field__floating-label': hasFloatingLabel,
            'form-field__is-required': state.required,
            'form-field__is-disabled': state.disabled,
            'form-field__has-error': state.error,
        };

        // NOTE: Extend the form clesses adding also the floating variants
        if (hasFloatingLabel) {
            const isFloating = this.value || placeholder || hasFocus || state.disabled;
            classes['form-field__is-floating'] = isFloating;
        }

        return classes;
    }

    get hasMessages() {
        const { messages } = this.props;
        const hasErrors = Array.isArray(messages.error) && !!messages.error.length;
        return hasErrors || !!messages.info;
    }

    get id() {
        return this._id;
    }

    updateValue(value) {
        if (this.props.onInput) {
            this.props.onInput(value);
        } else {
            this.setState({ value });
        }
    }

    /**
     * The value can be inferred by the props only if an onInput function was defined
     */
    get value() {
        return this.props.onInput ? this.props.value : this.state.value;
    }

    renderMessages() {
        const { messages } = this.props;

        return (
            <div className="form-field--message-container">
                { looppa(messages.error)((error, i) => (
                    <span role="alert" key={i} className="form-field--message form-field--message__error">
                        {error}
                    </span>
                ))}
                { looppa(messages.info)((info, i) => (
                    <span key={i} className="form-field--message form-field--message__info">
                        { info }
                    </span>
                ))}
            </div>
        );
    }

    render() {
        const { component, ...props } = this.props;
        // proxy some of the parent method to communicate with the child component
        const childrenProps = Object.assign(props, {
            onFocus: this.onFocus.bind(this),
            onBlur: this.onBlur.bind(this),
            updateValue: this.updateValue.bind(this),
            setStateClasses: this.setStateClasses.bind(this),
            actionCount: this.actionCount,
            formClasses: this.formClasses,
            hasFocus: this.state.hasFocus,
            value: this.value,
            id: this.id,
        });

        const facet = (Array.isArray(props.facet) ? props.facet : [props.facet]).map(f => `form-field__${ f }`);

        return (
            <div className={ classnames([
                'form-field',
                facet,
                { [`form-field__${ props.facet }-${ props.variant }`]: props.variant },
                this.state.stateClasses,
                this.formClasses,
            ]) }>
                { React.createElement(component, childrenProps) }
                { this.hasMessages ? this.renderMessages() : '' }
            </div>
        );
    }
}









// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/form/form-field/index.js